/**
 * @fileoverview Revoke-one-session mutation hook.
 * @description Wraps DELETE /identity/sessions/:id in a TanStack mutation, invalidating the
 * sessions list on success so the revoked entry disappears.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { SESSIONS_QUERY_KEY } from '@/features/auth/hooks/useSessions'
import { revokeSession } from '@/features/auth/services/session.service'

/**
 * @description Revokes one of the caller's own sessions and refreshes the sessions list.
 * @returns {ReturnType<typeof useMutation<void, unknown, string>>} The mutation object (mutate
 * with a sessionId, isPending, ...).
 */
export function useRevokeSession() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: revokeSession,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SESSIONS_QUERY_KEY })
    },
  })
}
